import { render, staticRenderFns } from "./ExamAttributeTypePercentage.vue?vue&type=template&id=78599889&scoped=true&"
import script from "./ExamAttributeTypePercentage.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeTypePercentage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78599889",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
